import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Chips, Empty, Loading, PageHead, Stat, fmtWhen, useAdmin } from "./ui";
import { DataTools } from "./DataTools";

export default function Subscribers() {
  const { data } = useAdmin("subscribers", "/admin/subscribers");
  const [list, setList] = useState("all");
  const [q, setQ] = useState("");
  const qc = useQueryClient();
  const lists = [...new Set((data || []).map((s) => s.list_name))];
  const shown = (data || []).filter((s) => (list === "all" || s.list_name === list) && (!q || `${s.name} ${s.email}`.toLowerCase().includes(q.toLowerCase())));
  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.email} from ${s.list_name}?`)) return;
    await api.delete(`/admin/subscribers/${s.id}`);
    toast.success("Removed");
    qc.invalidateQueries({ queryKey: ["admin", "subscribers"] });
  };
  return (
    <div data-testid="admin-subscribers">
      <PageHead eyebrow="From your pop-ups" title="Subscribers">
      </PageHead>
      <DataTools section="subscribers" label="subscribers" exportUrl="/admin/subscribers/export" filename="waxmoi-subscribers.xlsx" onPurged={() => qc.invalidateQueries({ queryKey: ["admin"] })} />
      <div className="ad-stats">
        <Stat label="Total" value={(data || []).length} testId="subscribers-total" />
        {lists.map((l) => <Stat key={l} label={l} value={(data || []).filter((s) => s.list_name === l).length} />)}
      </div>
      <input className="ad-search" placeholder="Search name or email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="subscribers-search" />
      <Chips options={[["all", "All lists"], ...lists.map((l) => [l, l])]} value={list} onChange={setList} testPrefix="subscribers-filter" />
      {!data ? <Loading /> : shown.length === 0 ? <Empty>No sign-ups yet.</Empty> : (
        <div className="ad-table" data-testid="subscribers-table">
          {shown.map((s) => (
            <div className="ad-trow" key={s.id} data-testid={`subscriber-row-${s.id}`}>
              <div><strong>{s.name}</strong><small>{s.email}</small></div>
              <div><small>{s.list_name}{s.birthday && ` · Birthday ${s.birthday}`}</small><small>{fmtWhen(s.created_at)}</small></div>
              <div className="ad-tright"><button className="ad-icon-btn" onClick={() => remove(s)} aria-label="Remove" data-testid="subscriber-delete-button"><Trash2 size={15} /></button></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
